import { render, staticRenderFns } from "./SalesFulfilledSalesOrder.vue?vue&type=template&id=a4c8f1a2"
import script from "./SalesFulfilledSalesOrder.vue?vue&type=script&lang=ts"
export * from "./SalesFulfilledSalesOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports